import type { JSX } from 'react';

import { Activities, ActivityConfig, INACTIVE_COLOR } from '../../enums/Activities';
import { MAXIMUM_TWO_WEEKLY_DRIVING_MINUTES } from '../../legalDrivingRestrictions';
import { EmptyDataIconWithTooltip } from '../elements/EmptyDataIcon';
import { TimeScaleBarComponent } from '../elements/TimeScaleBarComponent';
import type { DurationAndItems } from './types';

interface CurrentDrivingDoubleWeekCellProps {
    value?: DurationAndItems;
}

export const CurrentDrivingDoubleWeekCell = (props: CurrentDrivingDoubleWeekCellProps): JSX.Element => {
    const { value } = props;

    if (!value || value.duration === undefined) {
        return <EmptyDataIconWithTooltip />;
    }

    const percentageOfTime = (100 * value.duration) / MAXIMUM_TWO_WEEKLY_DRIVING_MINUTES;

    const progressParts = [
        {
            percentage: percentageOfTime,
            color: ActivityConfig[Activities.DRIVING].color,
            tooltipId: 'intl-msg:timed.driving-time-table.fortnightlyDrivingTime',
        },
        {
            percentage: 100 - percentageOfTime,
            color: INACTIVE_COLOR,
            tooltipId: 'intl-msg:timed.driving-time-table.maximum90Hours',
        },
    ];

    return (
        <TimeScaleBarComponent
            numberValue={value.duration}
            progressParts={progressParts}
            infringementLevel={value?.level}
            textColor={ActivityConfig[Activities.DRIVING].color}
        />
    );
};
